<template>
  <router-view></router-view>
</template>

<script>

/* eslint-disable */

import {Hub, Logger} from "aws-amplify";
import {Auth} from "@aws-amplify/auth";
import {API} from "@aws-amplify/api";
import {graphqlOperation} from "@aws-amplify/api-graphql";
import {userByEmail} from "@/graphql/queries";
import {onUpdateAccount} from "@/graphql/subscriptions";

// import {bus} from './main';

const logger = new Logger("main");

const OnAccountUpdated = `
  subscription OnAccountUpdated($id: ID!) {
    onAccountUpdated(id: $id) {
      id
    }
  }
`;

export default {
  name: 'app',
  data() {
    return {

    };
  },
  async created() {
    let that = this;

    await this.setAuthUser();

    Hub.listen('auth', (data) => {
      that.setAuthUser();

      let signedIn = false;
      switch (data.payload.event) {
        case 'signIn':
          console.log('user signed in');
          signedIn = true;
          break;
        case 'signUp':
          console.log('user signed up');
          signedIn = true;
          break;
        case 'signOut':
          console.log('user signed out');
          break;
        case 'signIn_failure':
          console.log('user sign in failed');
          break;
        case 'configured':
          console.log('the Auth module is configured');
          break;
        default:
          console.log('default');
          break;
      }

      if (signedIn)
        that.$router.replace('/cabinet/console/accounts').catch(err => {
        });
      ;
    });

    // bus.$on("themeUpdated", this.applyTheme);
    this.emitter.on("themeUpdated", this.applyTheme)
  },
  destroyed() {
    // bus.$off("themeUpdated", this.applyTheme);
    this.emitter.off("themeUpdated", this.applyTheme)
  },
  mounted() {
    // document.title = 'Cabinet';

    let htmlElement = document.documentElement;
    let theme = localStorage.getItem("theme");

    if (theme === 'dark') {
      htmlElement.setAttribute('theme', 'dark')
      this.darkMode = true
    } else {
      htmlElement.setAttribute('theme', 'light');
      this.darkMode = false
    }
  },
  methods: {
    applyTheme() {
      this.darkMode = !this.darkMode;

      let htmlElement = document.documentElement;

      if (this.darkMode) {
        localStorage.setItem("theme", 'dark');
        htmlElement.setAttribute('theme', 'dark');
      } else {
        localStorage.setItem("theme", 'light');
        htmlElement.setAttribute('theme', 'light');
      }
    },
    async setAuthUser() {
      let that = this;

      let authUser = await Auth.currentAuthenticatedUser()
          .then(user => {
            logger.debug('--- AUTH USER ---');
            logger.debug(user);
            return user;
          })
          .catch(err => {
            logger.debug(err);
            return null;
          });

      if (authUser != null) {
        this.$store.commit('setAuthUser', authUser);

        let email = authUser.attributes.email;
        that.getUserByEmail(email);
        that.subscribeToAccountChanges("73c389fe-e869-4664-8491-82784f1e856b");

      } else {
        logger.error('NULL USER');
        this.$store.commit('clearUser');
      }
    },
    async getUserByEmail(email) {
      return await API.graphql(graphqlOperation(userByEmail, {"email": email})).then((result) => {
        let items = result.data.userByEmail.items;
        if (items != null && items.length > 0) {
          let user = items[0];
          logger.debug('--- USER ---');
          this.$store.commit('setUser', user);

          return user;
        } else {
          logger.debug('ERROR: No user items');
        }
      }).catch((error) => {
        logger.debug('ERROR: ??? ');
        logger.debug(error)
        return null;
      });
    },
    subscribeToAccountChanges(accountID) {
      let that = this;
      API.graphql(graphqlOperation(OnAccountUpdated, {
        "id": accountID
      }))
          .subscribe({
            next: (eventData) => {
              let result = eventData.value.data.onUpdateAccount;
              console.log('--- SUBSCRIPTION UPDATE ---');
              console.log(result);

              that.getUserByEmail("saavedraerwin@gmail.com");
            }
          });
    }
  }
}
</script>

<style lang="scss">
@import 'assets/css/style';
</style>
